module.exports = __webpack_public_path__ + "home/img/bg-2.2522efd2.webp";